import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = 'Blog | LumaSeeker — Magnifying Glass for Seniors';
    fetch('/api/notion-posts')
      .then(r => { if (!r.ok) throw new Error(); return r.json(); })
      .then(data => { setPosts(Array.isArray(data) ? data : []); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-surface text-on-surface" style={{ fontFamily: "'Lexend', sans-serif" }}>

      {/* Nav */}
      <header className="w-full sticky top-0 z-50 bg-surface border-b border-outline-variant/20">
        <nav className="flex justify-between items-center px-6 md:px-12 py-5 max-w-screen-2xl mx-auto">
          <Link to="/" className="flex items-center gap-3">
            <img src="/favicon-32x32.png" alt="LumaSeeker" className="h-10 w-auto" />
            <span className="text-xl font-bold tracking-wider text-primary uppercase">LumaSeeker</span>
          </Link>
          <Link to="/" className="btn-primary px-5 py-2 font-bold text-sm">← Back to Home</Link>
        </nav>
      </header>

      {/* Hero */}
      <section className="px-6 md:px-12 py-16 md:py-24 max-w-screen-xl mx-auto">
        <span className="text-secondary font-bold tracking-widest uppercase block mb-4" style={{ fontSize: '0.85rem' }}>
          Resources & Guides
        </span>
        <h1 className="font-extrabold text-primary mb-4" style={{ fontSize: 'clamp(2rem, 4vw, 3.5rem)', lineHeight: 1.1 }}>
          Magnifying Glass Blog
        </h1>
        <p className="text-on-surface-variant max-w-2xl" style={{ fontSize: 'clamp(1.05rem, 1.4vw, 1.25rem)' }}>
          Guides and tips for seniors, caregivers, and anyone looking for better vision aids.
        </p>
      </section>

      {/* Posts */}
      <section className="px-6 md:px-12 pb-24 max-w-screen-xl mx-auto">
        {loading ? (
          <p className="text-on-surface-variant text-lg">Loading articles…</p>
        ) : posts.length === 0 ? (
          <p className="text-on-surface-variant text-lg">No articles published yet.</p>
        ) : (
          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            {posts.map(post => (
              <Link key={post.id} to={`/blog/${post.slug}`} className="group block bg-surface-container-low rounded-xl p-8 atmospheric-shadow hover:shadow-lg transition-shadow">
                <p className="text-secondary text-sm font-semibold mb-3 uppercase tracking-wide">{post.date}</p>
                <h2 className="font-bold text-primary mb-3 group-hover:text-secondary transition-colors" style={{ fontSize: 'clamp(1.1rem, 1.4vw, 1.3rem)' }}>
                  {post.title}
                </h2>
                <p className="text-on-surface-variant leading-relaxed text-sm">{post.description}</p>
                <span className="inline-block mt-4 text-secondary font-semibold text-sm">Read more →</span>
              </Link>
            ))}
          </div>
        )}
      </section>

      <footer className="border-t border-outline-variant/20 px-6 md:px-12 py-8 text-center text-on-surface-variant text-sm">
        © 2026 LumaSeeker. Empowering vision for a brighter tomorrow.
      </footer>
    </div>
  );
}
